import { lazyLoad } from 'app/utils/loadable'

export const PersonalInformationPage = lazyLoad(
  () => import('./index'),
  module => module.PersonalInformationPage
)
